export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/RO-366f794ab7bc18b1b7acffa361d9f700.png";